export default __webpack_public_path__ + "static/media/tmlc.f16caee3.png";